/* eslint-disable  */
import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes, redirect } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import VehicleForm from "./components/vehicle";
import LoginForm from "./components/LoginForm";
import RegisterForm from "./components/customer";
import RegisterForms from "./components/customeradd";
import Addvechicle from "./components/vehiclelist";
import UserForm from "./components/user";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Parkingdata from "./components/ParkingVideo";
import TenantHistory from "./components/TenantHistory";
import Reports from "./components/reports";
import AvigilonSync from "./components/avisync";
import CustomDeleteModal from "./components/CustomDeleteModal"
import Zero5PendingUpdates from "./pages/superadmin/Zero5PendingUpdates";
import VisitorsLog from "./components/VisitorsLog";






function App() {
    var isLoggedIn = false;
    const parseJwt = (token) => {
        try {
            return JSON.parse(atob(token.split('.')[1]));
        } catch (e) {
            return null;
        }
    };

    var roles = JSON.parse(localStorage.getItem("MCData"));
    // console.log("roles", roles?.token);

    const decodedJwt = parseJwt(roles?.token);
    if (roles == null) {
        isLoggedIn = false;

    }
    else if (decodedJwt.exp * 1000 < Date.now()) {
        isLoggedIn = false;
    }
    
    else if (roles && roles?.company === "0" 
    &&
       
        (
            (

                (window.location.href.indexOf("register") > -1) || (window.location.href.indexOf("registers") > -1) || (window.location.href.indexOf("vehicle") > -1)
                || (window.location.href.indexOf("user") > -1) || ((window.location.href.indexOf("dashboard") > -1)) || (window.location.href.indexOf("user#") > -1) 
            )
        )
    ) 
    {
        isLoggedIn = true;
    }
    // else if (roles && roles.company !== "0" && 
        
    //     (
    //         (
    //             (window.location.href.indexOf("dashboard") > -1) || (window.location.href.indexOf("register") > -1) ||
    //             (window.location.href.indexOf("registers") > -1)
    //         )
    //     )
    // ) {
    //     isLoggedIn = true;
    // }
    
    else if (roles && roles?.company != "0" && 
        
    (
        (
            (window.location.href.indexOf("user#") > -1) 
        )
    )
) {
    isLoggedIn = false;
}
    else{
        isLoggedIn=true; 
     }
    return (
        <div className="App">
            <Router>
                <Routes>
                    {/* <Route path="/" element={<Login />} /> */}
                    {isLoggedIn ? <>
                        <Route path="/" element={<LoginForm />} />
                        <Route path="/dashboard" element={<RegisterForm />} />
                        <Route path="/register" element={<RegisterForm />} />
                        <Route path="/registers" element={<RegisterForms />} />
                        <Route path="/vehicle" element={<VehicleForm />} />
                        <Route path="/vehicleadd" element={<Addvechicle />} />
                        <Route path="/user" element={<UserForm />} />
                        <Route path="/parking" element={<Parkingdata/>} />
                        <Route path="/tenant" element={<TenantHistory/>} />
                        <Route path="/reports" element={<Reports/>} />
                        <Route path="/avisync" element={<AvigilonSync/>} />
                        <Route path="/superadmin/zero5-pending-updates" element={<Zero5PendingUpdates/>} />
                        <Route path="/customdelete" element={<CustomDeleteModal/>} />
                        <Route path="/visitorslog" element={<VisitorsLog/>}/>
                    </>
                        :
                        <Route path="*" element={<LoginForm />} />}
                </Routes>
            </Router>
        </div>
    );
}

export default App;
